import { render, staticRenderFns } from "./SubmitFeedback.vue?vue&type=template&id=343c1db9&scoped=true"
import script from "./SubmitFeedback.vue?vue&type=script&lang=js"
export * from "./SubmitFeedback.vue?vue&type=script&lang=js"
import style0 from "./SubmitFeedback.vue?vue&type=style&index=0&id=343c1db9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343c1db9",
  null
  
)

export default component.exports